import { Card, CardContent, Box } from "@mui/material";
import { cordsType } from "../../pages/exams/Template/Masters/ListWrapper";
import { ObjectValues } from "../../pages/login";
import CardHeader from "./layouts/CardHeader";
import CountChips from "./layouts/CountChips";
import CardFooter from "./layouts/CardFooter";
import { displayRow, justifEnd, rowSB } from "../../GlobalStyles";
import CustomPopover from "../CustomPopover";
import { Info } from "@mui/icons-material";
export interface ExamProps {
  data: any;
  onclick?: () => void;
  onOpen?: () => void | undefined;
  cardsSelected: cordsType;
  setCardsSelected: (val: ObjectValues) => void;
  tempSelected: ObjectValues | null;
  child?: any;
  selected?: any;
  selectedData?: any;
}

function Exam({
  data,
  onclick,
  onOpen,
  setCardsSelected,
  cardsSelected,
  tempSelected,
  child,
  selected,
  selectedData,
}: ExamProps) {
  console.log(data, "tempSelected", tempSelected);
  const tempS = tempSelected?.data
    ? data.name === tempSelected?.data?.name &&
      data.id === tempSelected?.data.id
    : false;
  const chipConfigs = [
    (data.total_goals || data.total_goals === 0) && {
      key: "goal",
      label: "Goals",
      value: `${
        selectedData.goals?.length ? `${selectedData.goals?.length}/` : ""
      }${data.total_goals}`,
      color: "#eff6ff",
      text: "#2563eb",
      canClick: () => tempS,
      onClick: () => {
        if (cardsSelected.goal) {
          setCardsSelected({
            goal: false,
            section: false,
            unit: false,
            topic: false,
            subtopic: false,
            cluster: false,
            question: false,
          });
        } else {
          setCardsSelected({
            goal: true,
          });
        }
      },
      selected: () => (tempS ? cardsSelected.goal : false),
    },
    (data.total_sections || data.total_sections === 0) && {
      key: "section",
      label: "Sections",
      value: `${
        selectedData.sections?.length ? `${selectedData.sections?.length}/` : ""
      }${data.total_sections}`,
      color: "#f0fdf4",
      text: "#16a34a",
      canClick: () => tempS && cardsSelected.goal,
      onClick: () => {
        if (cardsSelected.section) {
          setCardsSelected({
            section: false,
            unit: false,
            topic: false,
            subtopic: false,
            cluster: false,
            question: false,
          });
        } else {
          setCardsSelected({
            section: true,
          });
        }
      },
      selected: () => (tempS ? cardsSelected.section : false),
    },
    (data.total_units || data.total_units === 0) && {
      key: "unit",
      label: "Units",
      value: `${
        selectedData.units?.length ? `${selectedData.units?.length}/` : ""
      }${data.total_units}`,
      color: "#faf5ff",
      text: "#9333ea",
      canClick: () => tempS && cardsSelected.goal && cardsSelected.section,
      onClick: () => {
        if (cardsSelected.unit) {
          setCardsSelected({
            unit: false,
            topic: false,
            subtopic: false,
            cluster: false,
            question: false,
          });
        } else {
          setCardsSelected({
            unit: true,
          });
        }
      },
      selected: () => (tempS ? cardsSelected.unit : false),
    },
    (data.total_topics || data.total_topics === 0) && {
      key: "topic",
      label: "Topics",
      value: `${
        selectedData.topics?.length ? `${selectedData.topics?.length}/` : ""
      }${data.total_topics}`,
      color: "#fff7ed",
      text: "#ea580c",
      canClick: () =>
        tempS &&
        cardsSelected.goal &&
        cardsSelected.section &&
        cardsSelected.unit,
      onClick: () => {
        if (cardsSelected.topic) {
          setCardsSelected({
            topic: false,
            subtopic: false,
            cluster: false,
            question: false,
          });
        } else {
          setCardsSelected({
            topic: true,
          });
        }
      },
      selected: () => (tempS ? cardsSelected.topic : false),
    },
    (data.total_subtopics || data.total_subtopics === 0) && {
      key: "subtopic",
      label: "Subtopics",
      value: `${
        selectedData.subtopics?.length ? `${selectedData.subtopics?.length}/` : ""
      }${data.total_subtopics}`,
      color: "#fef2f2",
      text: "#dc2626",
      canClick: () =>
        tempS &&
        cardsSelected.goal &&
        cardsSelected.section &&
        cardsSelected.unit &&
        cardsSelected.topic,
      onClick: () => {
        if (cardsSelected.subtopic) {
          setCardsSelected({
            subtopic: false,
            cluster: false,
            question: false,
          });
        } else {
          setCardsSelected({
            subtopic: true,
          });
        }
      },
      selected: () => (tempS ? cardsSelected.subtopic : false),
    },
    (data.total_clusters || data.total_clusters === 0) && {
      key: "cluster",
      label: "Clusters",
      value: `${
        selectedData.clusters?.length ? `${selectedData.clusters?.length}/` : ""
      }${data.total_clusters}`,
      color: "#fef3c7",
      text: "#d97706",
      canClick: () =>
        tempS &&
        cardsSelected.goal &&
        cardsSelected.section &&
        cardsSelected.unit &&
        cardsSelected.topic &&
        cardsSelected.subtopic,
      onClick: () => {
        if (cardsSelected.cluster) {
          setCardsSelected({
            cluster: false,
            question: false,
          });
        } else {
          setCardsSelected({
            cluster: true,
            question: true,
          });
        }
      },
      selected: () => (tempS ? cardsSelected.cluster : false),
    },
    {
      key: "question",
      label: "Questions",
      value: data.total_questions,
      color: "#eef2ff",
      text: "#4f46e5",
      canClick: () => false, // Not clickable
      onClick: undefined,
      selected: () => (tempS ? cardsSelected.question : false),
    },
  ].filter((s) => s);
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: "none",
        transform: tempS ? "scale(1.01)" : "none",
        border: tempS ? "1px solid #519C66" : "1px solid #e5e7eb",
        // cursor: "n",
        transition: "all 0.2s ease-in-out",
        // "&:hover": {
        //   boxShadow: 4,
        //   transform: "scale(1.01)",
        //   border: "2px dashed #519C66",
        // },
      }}
    >
      <CardContent
        sx={{
          background: child ? "#eff6ff" : "transparent",
          padding: "12px !important",
          borderBottom: child ? "1px solid #e5e7eb" : "none",
        }}
      >
        <Box sx={{ ...rowSB }}>
          <CardHeader
            onClick={onclick}
            onOpen={onOpen}
            checked={selected}
            selected={child ? true : false}
            name={data.name}
            description={data.description}
            id={data.id}
            status={data.status}
            is_active={data.is_active}
            primary_language={data.primary_language}
          />
          <Box sx={{ flex: 8 }}>
            <Box sx={{ gap: "8px", ...displayRow, ...justifEnd }}>
              {chipConfigs.map((chip) => (
                <Box
                  key={chip.key}
                  sx={{
                    maxWidth: "102px !important",
                    width: "auto",
                  }}
                >
                  <CountChips
                    label={chip.label}
                    value={chip.value}
                    color={chip.color}
                    text={chip.text}
                    selected={chip.selected()}
                    onClick={chip.canClick() ? chip.onClick : undefined}
                  />
                </Box>
              ))}
              <Box sx={{ maxWidth: "fit-content" }}>
                <CustomPopover
                  icon={
                    <Info
                      sx={{ color: "#9ca3af", height: "16px", width: "16px" }}
                    />
                  }
                  content={
                    <CardFooter
                      internal_remark={data.internal_remark}
                      created_at={data.created_at}
                      created_by_id={data.created_by_id}
                      modified_at={data.modified_at}
                      modified_by_id={data.modified_by_id}
                    />
                  }
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </CardContent>
      {child}
    </Card>
  );
}

export default Exam;
